(function(){
  'use strict';
  var qs=function(s,c){return (c||document).querySelector(s)};
  var qsa=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};

  function safeStorage(){try{return window.localStorage}catch(error){return null}}
  function readCookie(name){var prefix=name+'=';var parts=document.cookie?document.cookie.split(';'):[];for(var i=0;i<parts.length;i++){var part=parts[i].trim();if(part.indexOf(prefix)===0)return decodeURIComponent(part.slice(prefix.length))}return null}
  function writeCookie(name,value,days){var date=new Date(Date.now()+days*86400000);document.cookie=name+'='+encodeURIComponent(value)+'; expires='+date.toUTCString()+'; path=/; SameSite=Lax'}

  /* Product-card media scrub. Critical information never depends on it. */
  qsa('[data-aura-card-media]').forEach(function(media){
    var images=qsa('.aura-product-card__image',media);if(images.length<2)return;
    var bars=qsa('.aura-product-card__media-progress span',media);var count=qs('[data-aura-card-count]',media);
    function activate(index){index=Math.max(0,Math.min(images.length-1,index));images.forEach(function(img,i){img.classList.toggle('is-active',i===index)});bars.forEach(function(bar,i){bar.classList.toggle('is-active',i===index)});if(count)count.textContent=String(index+1).padStart(2,'0')+' / '+String(images.length).padStart(2,'0')}
    media.addEventListener('pointermove',function(event){if(event.pointerType==='touch')return;var rect=media.getBoundingClientRect();var ratio=(event.clientX-rect.left)/Math.max(1,rect.width);activate(Math.floor(ratio*images.length))});
    media.addEventListener('pointerleave',function(){activate(0)});
  });

  /* Collection filters: explicit dialog controller + native GET form. */
  var activeFilterDialog=null;
  function closeFilterDialog(dialog,restoreFocus){
    if(!dialog)return;
    try{if(typeof dialog.close==='function'&&dialog.open)dialog.close();else dialog.removeAttribute('open')}catch(error){dialog.removeAttribute('open')}
    document.body.classList.remove('is-locked');
    if(restoreFocus!==false&&dialog._auraReturnFocus&&document.contains(dialog._auraReturnFocus))dialog._auraReturnFocus.focus();
    dialog._auraReturnFocus=null;
    if(activeFilterDialog===dialog)activeFilterDialog=null;
  }
  qsa('[data-aura-filter-open]').forEach(function(button){
    button.addEventListener('click',function(){
      var id=button.getAttribute('data-aura-filter-open');
      var dialog=id?document.getElementById(id):null;
      if(!dialog)return;
      if(activeFilterDialog&&activeFilterDialog!==dialog)closeFilterDialog(activeFilterDialog,false);
      dialog._auraReturnFocus=button;
      try{if(typeof dialog.showModal==='function')dialog.showModal();else dialog.setAttribute('open','')}catch(error){dialog.setAttribute('open','')}
      activeFilterDialog=dialog;
      document.body.classList.add('is-locked');
      var first=qs('[data-aura-filter-close]',dialog)||qs('input,button,select,a[href]',dialog);
      window.setTimeout(function(){if(first)first.focus()},20);
    });
  });
  qsa('[data-aura-filter-dialog]').forEach(function(dialog){
    qsa('[data-aura-filter-close]',dialog).forEach(function(button){button.addEventListener('click',function(){closeFilterDialog(dialog,true)})});
    dialog.addEventListener('cancel',function(event){event.preventDefault();closeFilterDialog(dialog,true)});
    dialog.addEventListener('click',function(event){if(event.target===dialog)closeFilterDialog(dialog,true)});
    dialog.addEventListener('close',function(){document.body.classList.remove('is-locked');if(activeFilterDialog===dialog)activeFilterDialog=null});
  });
  qsa('[data-aura-sort-select]').forEach(function(select){
    select.addEventListener('change',function(){var form=select.form||select.closest('form');if(form)form.submit()});
  });

  /* Welcome offer V4 — compact, engagement-aware, native Shopify form. */
  qsa('[data-aura-promo]').forEach(function(dialog){
    if(typeof dialog.showModal!=='function')return;

    var storage=safeStorage();
    var dismissedKey='aura:welcome:dismissed';
    var claimedKey='aura:welcome:claimed';
    var sessionSeenKey='aura:welcome:session-seen';
    var submittedKey='aura:welcome:submitted';

    var success=dialog.dataset.success==='true';
    var delay=Math.max(5,Number(dialog.dataset.delay||8))*1000;
    var days=Math.max(1,Number(dialog.dataset.dismissDays||4));

    var armed=false;
    var opened=false;
    var interactionDetected=false;
    var retryTimer=0;

    function stored(key){try{return storage&&storage.getItem(key)}catch(error){return null}}
    function mark(key,value){try{if(storage)storage.setItem(key,String(value))}catch(error){}}
    function sessionStored(key){try{return window.sessionStorage&&window.sessionStorage.getItem(key)}catch(error){return null}}
    function markSession(key,value){try{if(window.sessionStorage)window.sessionStorage.setItem(key,String(value))}catch(error){}}

    /* Header panels (search, market) keep aria-modal="true" while hidden: only count panels actually displayed. */
    function isDisplayed(el){
      if(!el||el.hidden||el.closest('[hidden]')||el.getAttribute('aria-hidden')==='true')return false;
      var cs=window.getComputedStyle(el);
      if(cs.display==='none'||cs.visibility==='hidden'||Number(cs.opacity)===0)return false;
      var rect=el.getBoundingClientRect();
      return rect.width>0&&rect.height>0;
    }

    function uiIsBusy(){
      var active=document.activeElement;
      if(active&&/^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName))return true;
      if(document.body.classList.contains('is-locked'))return true;
      if(qs('dialog[open]:not([data-aura-promo])'))return true;
      if(qsa('[aria-modal="true"]:not(.aura-promo)').some(isDisplayed))return true;
      if(qsa('header [aria-controls][aria-expanded="true"]').some(function(btn){return isDisplayed(document.getElementById(btn.getAttribute('aria-controls')))}))return true;
      return false;
    }

    function canOpen(){
      if(opened||dialog.open)return false;
      if(qs('[data-aura-cookie]:not([hidden])'))return false;
      if(stored(claimedKey))return false;
      if(uiIsBusy())return false;

      var until=Number(stored(dismissedKey)||0);
      if(until&&until>Date.now())return false;
      if(sessionStored(sessionSeenKey))return false;

      return true;
    }

    function emit(name,detail){
      try{
        document.dispatchEvent(
          new CustomEvent(name,{detail:detail||{}})
        );
      }catch(error){}
    }

    function open(force){
      if(!force&&!canOpen())return false;
      if(dialog.open)return true;

      opened=true;
      markSession(sessionSeenKey,'1');

      try{
        dialog.showModal();
      }catch(error){
        dialog.setAttribute('open','');
      }

      emit('aura:promo:view',{success:success});
      return true;
    }

    function close(markDismiss,reason){
      if(dialog.open){
        try{
          dialog.close();
        }catch(error){
          dialog.removeAttribute('open');
        }
      }

      if(markDismiss){
        mark(
          dismissedKey,
          Date.now()+days*86400000
        );
      }

      emit(
        'aura:promo:close',
        {
          reason:reason||'close',
          success:success
        }
      );
    }

    function enoughScroll(){
      var threshold=
        window.innerWidth<900
          ?180
          :120;

      return (
        window.scrollY||
        window.pageYOffset||
        0
      )>threshold;
    }

    function tryOpen(force){
      if(!armed||opened)return;

      if(
        force||
        interactionDetected||
        enoughScroll()
      ){
        if(!open(false)){
          scheduleRetry();
        }
      }
    }

    function scheduleRetry(){
      if(retryTimer||opened)return;

      retryTimer=window.setTimeout(function(){
        retryTimer=0;

        if(armed&&!opened){
          tryOpen(true);
        }
      },1500);
    }

    if(success){
      mark(claimedKey,'1');

      /* Only a submission made from this popup opens its success view.
         Footer submissions or a bare ?customer_posted=true no longer open it. */
      if(sessionStored(submittedKey)){
        try{window.sessionStorage.removeItem(submittedKey)}catch(error){}

        window.setTimeout(function(){
          open(true);
        },80);
      }

    }else if(!stored(claimedKey)){

      window.setTimeout(function(){
        armed=true;
        tryOpen(false);
      },delay);

      /* Never block the offer forever if the visitor simply does not interact. */
      window.setTimeout(function(){
        if(armed&&!opened){
          tryOpen(true);
        }
      },delay+5000);

      var onScroll=function(){
        interactionDetected=true;
        tryOpen(false);

        if(opened){
          window.removeEventListener(
            'scroll',
            onScroll
          );
        }
      };

      var onPointer=function(){
        interactionDetected=true;
        tryOpen(false);
      };

      var onKey=function(){
        interactionDetected=true;
        tryOpen(false);
      };

      window.addEventListener(
        'scroll',
        onScroll,
        {passive:true}
      );

      document.addEventListener(
        'pointerdown',
        onPointer,
        {
          once:true,
          passive:true
        }
      );

      document.addEventListener(
        'keydown',
        onKey,
        {
          once:true
        }
      );

      document.addEventListener(
        'aura:cookie:resolved',
        function(){
          if(armed&&!opened){
            window.setTimeout(function(){
              tryOpen(true);
            },450);
          }
        },
        {
          once:true
        }
      );
    }

    qsa(
      '[data-aura-promo-close]',
      dialog
    ).forEach(function(btn){
      btn.addEventListener(
        'click',
        function(){
          close(!success,'button');
        }
      );
    });

    dialog.addEventListener(
      'cancel',
      function(event){
        event.preventDefault();
        close(!success,'escape');
      }
    );

    dialog.addEventListener(
      'click',
      function(event){
        if(event.target===dialog){
          close(!success,'backdrop');
        }
      }
    );

    var form=
      dialog.closest('form');

    if(form){
      form.addEventListener(
        'submit',
        function(){
          markSession(submittedKey,'1');
          emit(
            'aura:promo:submit',
            {}
          );
        }
      );
    }

    var copy=
      qs(
        '[data-aura-promo-copy]',
        dialog
      );

    if(copy){
      copy.addEventListener(
        'click',
        function(){

          var code=
            dialog.dataset.code||'';

          if(!code){
            return;
          }

          var label=
            qs(
              '[data-aura-promo-copy-label]',
              copy
            );

          var promise=
            navigator.clipboard&&
            navigator.clipboard.writeText

              ?navigator.clipboard.writeText(code)
              :Promise.reject();

          promise
            .catch(function(){

              var ta=
                document.createElement(
                  'textarea'
                );

              ta.value=code;
              ta.style.position='fixed';
              ta.style.opacity='0';

              document.body.appendChild(
                ta
              );

              ta.select();

              document.execCommand(
                'copy'
              );

              ta.remove();
            })

            .finally(function(){

              emit(
                'aura:promo:copy',
                {
                  code:code
                }
              );

              if(label){
                var old=
                  label.textContent;

                label.textContent='✓';

                window.setTimeout(function(){
                  label.textContent=old;
                },1600);
              }
            });
        }
      );
    }
  });

  /* Cookie consent persistence. Never reopens on navigation after a decision. */
  qsa('[data-aura-cookie]').forEach(function(banner){
    var storage=safeStorage();
    var version=banner.dataset.consentVersion||'1';
    var key='aura:consent:v'+version;
    var cookieKey='aura_consent_v'+version;
    var prefs=qs('[data-aura-cookie-prefs]',banner);
    var customize=qs('[data-aura-cookie-customize]',banner);

    var inputs={
      preferences:qs('[data-aura-cookie-purpose="preferences"]',banner),
      analytics:qs('[data-aura-cookie-purpose="analytics"]',banner),
      marketing:qs('[data-aura-cookie-purpose="marketing"]',banner)
    };

    function read(){
      var raw=null;

      try{
        raw=storage&&storage.getItem(key);
      }catch(error){}

      if(!raw){
        raw=readCookie(cookieKey);
      }

      if(!raw){
        return null;
      }

      try{
        return JSON.parse(raw);
      }catch(error){
        return null;
      }
    }

    function write(values){
      var payload=
        JSON.stringify({
          version:version,
          values:values,
          decidedAt:Date.now()
        });

      try{
        if(storage){
          storage.setItem(
            key,
            payload
          );
        }
      }catch(error){}

      writeCookie(
        cookieKey,
        payload,
        365
      );

      return payload;
    }

    function apply(values){
      Object.keys(inputs).forEach(function(k){
        if(inputs[k]){
          inputs[k].checked=
            !!values[k];
        }
      });
    }

    function hide(){
      banner.hidden=true;

      banner.classList.remove(
        'is-visible'
      );

      document.dispatchEvent(
        new CustomEvent(
          'aura:cookie:resolved'
        )
      );
    }

    function show(custom){
      banner.hidden=false;

      requestAnimationFrame(function(){
        banner.classList.add(
          'is-visible'
        );
      });

      if(custom&&prefs){
        prefs.hidden=false;

        if(customize){
          customize.setAttribute(
            'aria-expanded',
            'true'
          );
        }
      }
    }

    function sync(values){
      function set(){
        try{
          if(
            window.Shopify&&
            Shopify.customerPrivacy&&
            typeof Shopify.customerPrivacy.setTrackingConsent==='function'
          ){
            Shopify.customerPrivacy.setTrackingConsent(
              values,
              function(){}
            );
          }
        }catch(error){}
      }

      if(
        window.Shopify&&
        typeof Shopify.loadFeatures==='function'
      ){
        Shopify.loadFeatures(
          [
            {
              name:'consent-tracking-api',
              version:'0.1'
            }
          ],
          function(){
            set();
          }
        );
      }else{
        set();
      }
    }

    function resolve(values){
      write(values);
      apply(values);
      sync(values);
      hide();
    }

    var existing=
      read();

    if(
      existing&&
      existing.values
    ){
      apply(existing.values);
      hide();
    }else{
      show(false);
    }

    if(customize){
      customize.addEventListener(
        'click',
        function(){

          var opening=
            prefs&&
            prefs.hidden;

          if(prefs){
            prefs.hidden=!opening;
          }

          customize.setAttribute(
            'aria-expanded',
            opening?'true':'false'
          );
        }
      );
    }

    var accept=
      qs(
        '[data-aura-cookie-accept]',
        banner
      );

    if(accept){
      accept.addEventListener(
        'click',
        function(){
          resolve({
            preferences:true,
            analytics:true,
            marketing:true
          });
        }
      );
    }

    var reject=
      qs(
        '[data-aura-cookie-reject]',
        banner
      );

    if(reject){
      reject.addEventListener(
        'click',
        function(){
          resolve({
            preferences:false,
            analytics:false,
            marketing:false
          });
        }
      );
    }

    var save=
      qs(
        '[data-aura-cookie-save]',
        banner
      );

    if(save){
      save.addEventListener(
        'click',
        function(){
          resolve({
            preferences:
              !!(
                inputs.preferences&&
                inputs.preferences.checked
              ),

            analytics:
              !!(
                inputs.analytics&&
                inputs.analytics.checked
              ),

            marketing:
              !!(
                inputs.marketing&&
                inputs.marketing.checked
              )
          });
        }
      );
    }

    document.addEventListener(
      'click',
      function(event){

        if(
          !event.target.closest(
            '[data-aura-cookie-reopen]'
          )
        ){
          return;
        }

        event.preventDefault();

        var current=
          read();

        if(
          current&&
          current.values
        ){
          apply(current.values);
        }

        show(true);
      }
    );
  });
})();